import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/dist/types';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MySkillVerificationsService {

  constructor(private httpClient: HttpClient) { }

  getSkillVerificationListData(includeAll: boolean): Observable<any> {
    return this.httpClient.get(ApiConstants.My_Skill_Verifications_Api + "/" + includeAll);
  }

  /**
   * Verify selected skills in batch.
   * Backend handles all batching, categorization, and processing:
   * - Loads all skills by skillCode + userPuid in single batch query (performance optimized)
   * - Determines acknowledgement requirement from database (single source of truth)
   * - Validates status before processing
   * - Performs bulk updates (memory efficient)
   * - Handles audit and notifications automatically
   * 
   * @param skillsToVerify Array of skills with skillCode and userPuid
   * @returns Observable with verification summary (earnedCount, pendingAcknowledgementCount)
   */
  verifySkills(skillsToVerify: Array<{ skillCode: string; userPuid: string }>): Observable<any> {
    return this.httpClient.put(
      ApiConstants.Verify_Skills_Api,
      { skills: skillsToVerify }
    );
  }
}
